<i18n
  src="@/locales/views/agro_exporter/certifications/query_providers/show_producer.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/crop_field_certification.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('list_providers')"
    :params="{
      agro_exporter_id: agro_exporter_id
    }"
  ></go-back-link>
  <bread-crumbs :labels="[module_name, producer?.name]"></bread-crumbs>
  <template v-if="load_data_general">
    <div class="flex flex-row">
      <div class="panel-plain-label">
        <badge-default
          :label="
            crop_field_certifications.length +
            ' ' +
            $t('labels.total_number_crop_field_certifications')
          "
        />
      </div>
    </div>
    <div class="mt-8 flex flex-col">
      <alert-danger :errors_data="std_err" />
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.crop_field_certification.certification_id") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.crop_field_certification.renewal_date") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.crop_field_certification.expiration_date") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.crop_field_certification.active") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.crop_field_certification.expired_at") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    <i class="fa-solid fa-paperclip"></i>
                  </th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="crop_field_certification in crop_field_certifications"
                  :key="crop_field_certification.id"
                >
                  <td class="table-cell">
                    {{ crop_field_certification.certification.name }}
                  </td>
                  <td class="table-cell">
                    {{ dateFormatter(crop_field_certification.renewal_date) }}
                  </td>
                  <td class="table-cell">
                    {{
                      dateFormatter(crop_field_certification.expiration_date)
                    }}
                  </td>
                  <td class="table-cell">
                    <yes-no-label :value="crop_field_certification.active" />
                  </td>
                  <td class="table-cell">
                    <div
                      v-if="crop_field_certification.active"
                      v-html="expiredAt(crop_field_certification)"
                    ></div>
                  </td>
                  <td class="table-cell">
                    <i
                      v-if="crop_field_certification.certificate_filename"
                      :class="[
                        'cursor-pointer fa-solid',
                        crop_field_certification.downloading_certificate
                          ? 'fa-sync fa-spin'
                          : 'fa-download'
                      ]"
                      @click.prevent="
                        downloadCertificateFile(crop_field_certification)
                      "
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/certifications/query_providers/list_certifications.js";

export default {
  name: "ShowOrganization",
  data() {
    return {
      load_data_general: false,
      producer: {},
      crop_field_certifications: []
    };
  },
  props: {
    agro_exporter_id: { required: true },
    producer_id: { required: true }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.loadData())
    );
  },
  methods: {
    async loadData() {
      await this.fetchProducer();
      await this.fetchOrganizationCertifications();
      this.load_data_general = true;
    },
    async fetchProducer() {
      let response = await Requester.fetchProducer(
        this.agro_exporter_id,
        this.producer_id
      );

      this.producer = response.data;
    },
    async fetchOrganizationCertifications() {
      let response = await Requester.fetchCropFieldCertifications(
        this.agro_exporter_id,
        this.producer_id
      );

      this.crop_field_certifications = response.data;
      this.crop_field_certifications.forEach(crop_field_cert => {
        crop_field_cert['downloading_certificate'] = false
      })
    },
    async downloadCertificateFile(crop_field_certification) {
      crop_field_certification.downloading_certificate = true;
      try {
        var response = await Requester.downloadCfCertificateFile(
          this.agro_exporter_id,
          this.producer_id,
          crop_field_certification.id
        );
        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          crop_field_certification.certificate_filename
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
      crop_field_certification.downloading_certificate = false;
    },
    expiredAt(crop_field_certification) {
      let days = this.daysUntilExpirationDate(
        crop_field_certification.expiration_date
      );

      if (days > 0) {
        return `<span>
            <i class="fa-solid fa-circle-check text-green-500"></i>
            ${this.$t("labels.days", { days: this.numberWithPrecision(days) })}
            </span>`;
      } else {
        return `
            <span class="text-red-500">
            <i class="fa-solid fa-triangle-exclamation text-red-500"></i>
            ${this.$t("labels.expired_date")}
            </span>`;
      }
    }
  }
};
</script>
